var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("审核进度")))]), _c("a-timeline", _vm._l(_vm.list, function (item) {
    return _c("a-timeline-item", {
      key: item.id,
      attrs: {
        color: item.userName ? "green" : "blue"
      }
    }, [_c("p", {
      class: !item.isShow ? "color" : "",
      staticStyle: {
        cursor: "pointer"
      },
      style: item.id == _vm.scheduleInfo.id ? "color:#1890ff" : "",
      on: {
        click: function ($event) {
          return _vm.goInfoFun(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name === "报案信息" ? _vm.$t(item.name) : item.name) + " ")]), item.pendingInfo ? _c("p", {
      class: !item.isShow ? "color" : "",
      staticStyle: {
        color: "red"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("待操作人")) + ":" + _vm._s(item.pendingInfo) + " ")]) : _vm._e(), item.reviewedInfo ? _c("p", {
      class: !item.isShow ? "color" : ""
    }, [_vm._v(_vm._s(_vm.$t("操作人")) + ":" + _vm._s(item.reviewedInfo))]) : _vm._e(), item.operationAt ? _c("p", {
      class: !item.isShow ? "color" : ""
    }, [_vm._v(_vm._s(item.operationAt))]) : _vm._e()]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };